import Component from '@glimmer/component';
import { t, tKey } from 'ember-intl';
import importAsset from 'lumen/helpers/import-asset';
import type Highlight from 'lumen/models/roi-trophies/highlight';
import {
  HIGHLIGHT_PERIOD_TYPE,
  type ReservationGeneralData,
} from 'lumen/models/roi-trophies/highlight';
import lottieAnimation from 'lumen/modifiers/lottie-animation';

import GeneralRoiTrophiesCalendarDateLink from '../calendar-date-link';
import GeneralRoiTrophiesCountUpNumber from '../count-up-number';
import GeneralRoiTrophiesContentTrophyModalLayout from './trophy-modal-layout';

interface GeneralRoiTrophiesContentReservationGeneralSignature {
  Args: {
    highlight: Highlight;
  };
}

export default class GeneralRoiTrophiesContentReservationGeneral extends Component<GeneralRoiTrophiesContentReservationGeneralSignature> {
  get data(): ReservationGeneralData {
    return this.args.highlight.highlightData as ReservationGeneralData;
  }

  get sublineKey(): string {
    return this.args.highlight.periodType === HIGHLIGHT_PERIOD_TYPE.WEEK
      ? tKey('roi_trophies.reservation.subline_week_of')
      : tKey('roi_trophies.reservation.subline');
  }

  <template>
    <GeneralRoiTrophiesContentTrophyModalLayout>
      <:content>
        <div class="flex flex-col items-center gap-300">
          <div>
            <div class="heading-1">
              <GeneralRoiTrophiesCountUpNumber
                @prefix="+ "
                @target={{this.data.pickup}}
              />
              {{t "roi_trophies.reservations"}}
            </div>
            <div
              class="inline-flex items-center gap-100"
              data-test-id="reservation-general-subline"
            >
              {{t this.sublineKey}}
              <GeneralRoiTrophiesCalendarDateLink @highlight={{@highlight}} />
            </div>
          </div>
          <p class="text-300--regular text-neutral-subdued">{{t
              "roi_trophies.reservations_general.body"
            }}</p>
        </div>
      </:content>
      <:animation>
        <div
          {{lottieAnimation
            (importAsset "animations/roi-trophies/record.json")
            false
          }}
        />
      </:animation>
    </GeneralRoiTrophiesContentTrophyModalLayout>
  </template>
}
